<svelte:options customElement={{
  tag: 'accordion-item',
  shadow: 'none',
  props: {
    summary: { reflect: true, type: 'String' },
    variant: { reflect: true, type: 'String' },
    open: { reflect: true, type: 'Boolean' }
  }
}} />

<script>
  import { onMount } from 'svelte';
  /**
   * navi4：アコーディオン
   * パーツライブラリ準拠の mod-accordion 構造
   * @prop {string} summary - アコーディオンタイトル
   * @prop {string} variant - 'default' | 'qa' | 'card'
   * @prop {boolean} open - 開閉状態
   */
  export let summary = 'アコーディオンサンプル';
  export let variant = 'default';
  export let open = false;

  $: isQa = variant === 'qa';
  $: isCard = variant === 'card';
  $: variantClass = isQa ? ' _qa' : isCard ? ' _card' : '';
  $: detailsClass = `mod-accordion${variantClass} js-accordion`;

  let contentEl;

  onMount(() => {
    const host = contentEl.closest('accordion-item');
    if (!host) return;
    const detailsEl = host.querySelector('details');
    const nodesToMove = [];
    host.childNodes.forEach(node => {
      if (node !== detailsEl) nodesToMove.push(node);
    });
    nodesToMove.forEach(node => contentEl.appendChild(node));
  });
</script>

{#if isQa}
  <details class={detailsClass} bind:open>
    <summary class="mod-accordion-summary">
      <span class="mod-accordion-qa-icon">Q</span>
      <span>{summary}</span>
      <span class="mod-accordion-plus" aria-hidden="true"></span>
    </summary>
    <div class="mod-accordion-wrapper">
      <div class="mod-accordion-content">
        <span class="mod-accordion-qa-answer">A</span>
        <div bind:this={contentEl}></div>
      </div>
    </div>
  </details>
{:else}
  <details class={detailsClass} bind:open>
    <summary class="mod-accordion-summary">
      <span>{summary}</span>
      <span class="mod-accordion-plus" aria-hidden="true"></span>
    </summary>
    <div class="mod-accordion-wrapper">
      <div class="mod-accordion-content" bind:this={contentEl}></div>
    </div>
  </details>
{/if}
